const audioDescriptionTrackTemplate = ({audioDescriptionTrackSrc}) => `<audio class="audio-description-track" muted src="${audioDescriptionTrackSrc}" preload="auto"></audio>`;

export default audioDescriptionTrackTemplate;
